<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        
          <div class="card-custom-web">
            <br />
            <div class="text-center mt-4"><br /><br /><br />
              <img :src="this.$route.query.Image" />
              <br />
              <h3 class="title mt-4" style="color: #000A2C;">{{ this.$route.query.NickName }}</h3>
              <br />
              <h4 class="sub-title-header" style="color: #000A2C;">
                Nice photo!
              </h4>
            </div>

            
            
          </div>
        
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton color="info" class="btn-select-blue mt-5" @click="GoToRegisterSuccess()">Next</CButton>
      <br />
        <label class="mt-3 custom-label-note" style="color: #007CEF;">
          <span class="text-inline" @click="OpenUploadPopup()">Change Image</span> 
        </label>
    </div>
    
    <div class="header-top">Register Student</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
    <CModal size="md" :show.sync="UploadModal">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Upload New Profile Image
        </h3>
        <br />
      </div>
      <div class="text-center">
        <input
          type="file"
          id="file"
          ref="file"
          accept="image/jpeg"
          v-on:change="handleFileUpload()"
        />
        <br />
      </div>
      <template #footer>
        <CButton
          type="submit"
          color="info"
          class="p-2"
          @click="UpdateProfileImage()"
          >Upload</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
    data() {
    return {
      Image: this.$route.query.Image,
      NickName: this.$route.query.NickName,
      ExamId: this.$route.query.ExamId,
      UploadModal: false,
    };
  },
  methods: {
    // GoToSubject(){
    //   this.$router.push(
    //     "/RegisterStudentParentSubject?NickName=" +
    //       this.$route.query.NickName +
    //       "&Grade=" +
    //        this.$route.query.Grade + 
    //       "&Exam=" +
    //        this.$route.query.Exam + "&ExamId=" +
    //        this.$route.query.ExamId + "&Image=" + this.$route.query.Image
    //   );
    // },
    GoToRegisterSuccess() {
      this.$router.push(
        "/RegisterStudentParentSuccess?NickName=" +
          this.$route.query.NickName +
          "&Grade=" +
          this.$route.query.Grade +
          "&Exam=" +
          this.$route.query.Exam
      );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },
    OpenUploadPopup() {
      this.UploadModal = true;
    },
    RegisterNewStudent: function () {
      const formData = new FormData();
      formData.append("Name", this.$route.query.NickName);
      formData.append("ParentEmail", this.user.email);
      formData.append("Grade", this.$route.query.Grade);
      formData.append("Image", this.file);
      formData.append("NickName", this.$route.query.NickName);
      formData.append("Exam", this.$route.query.Exam);
      formData.append("SubjectId", this.$route.query.SubjectId);

      return this.$API
        .post(this.$RegisterNewStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.GoToImageSuccess();
            this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    UpdateProfileImage: function () {
      const formData = new FormData();
      formData.append("image", this.file);
      //formData.append("studentId", this.StudentId);

      return this.$API
        .post(this.$UpdateStudentProfileImage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}


</style>